import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import {
  Badge,
  Button,
  Checkbox,
  Collapse,
  Dropdown,
  Empty,
  Flex,
  Input,
  Tag,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import crossIcon from "../../assets/Icons/crossIcon.svg";
import favoIcon from "../../assets/Icons/favoIcon.svg";
import FilterIcon2 from "../../assets/Icons/FilterVariant2.svg";
import searchIcon from "../../assets/Icons/input-search-icon.svg";
import recentIcon from "../../assets/Icons/recentIcon.svg";
import starIcon from "../../assets/Icons/star.svg";

import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setQuery, clearQuery } from "../../store/filters";
import "./ActionHeader.scss";

const { Panel } = Collapse;

const FilterDropdown = ({
  setPrimaryItems,
  setSecondaryItems,
  secondaryItems,
  primaryItems,
  fetchData,
  fetchData2,
  fetchData3,
  variant = "1",
  updateApis = () => { }
}) => {
  const [open, setOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [selectedCategory, setSelectedCategory] = useState("portfolios");
  const [categorySelections, setCategorySelections] = useState({});
  const [readyToApply, setReadyToApply] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { portfolios } = useSelector((state) => state.portfolio);
  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { filter_list, query, analyse_filters } = useSelector((state) => state?.filters);
  const filterSource = variant === "1" ? analyse_filters : filter_list;


  const variant1Categories = [
    { title: "Recently Selected", value: "recently" },
    { title: "Favourites", value: "favourites" },
    { title: "State Wise", value: "state" },
    { title: "Status", value: "status" },
    { title: "Team Member", value: "team_member" },
    { title: "Team Leader", value: "team_leader" },
    { title: "Loan Type", value: "loan_type" },
    { title: "Agency", value: "agency" },
  ];

  const variant2Categories = [
    { title: "Recently Selected", value: "recently" },
    { title: "Favourites", value: "favourites" },
    { title: "Disposition", value: "disposition" },
    { title: "State Wise", value: "states" },
    { title: "Portfolio Wise", value: "portfolios" },
    { title: "Region Wise", value: "region" },
  ];

  const categories = variant === "2" ? variant2Categories : variant1Categories;



  useEffect(() => {
    if (query) {
      setCategorySelections(query);
    }
  }, [query]);


  const objectCategories = [
    "portfolios",
    "supervisors",
    "teamleads",
    "telecallers",
    "field_agents",
    "team_member",
    // "disposition",
  ];

 const toggleTrust = (trust) => {
  const prevSelected = categorySelections[selectedCategory] || [];
  let valueToStore;

  if (selectedCategory === "disposition") {
    valueToStore = trust?.key;
  } else if (objectCategories.includes(selectedCategory)) {
    valueToStore = trust?.id;
  } else {
    valueToStore = trust;
  }

  const updatedTrusts = prevSelected.includes(valueToStore)
    ? prevSelected.filter((t) => t !== valueToStore)
    : [...prevSelected, valueToStore];

  setCategorySelections({
    ...categorySelections,
    [selectedCategory]: updatedTrusts,
  });
};



 const handleSelectAll = () => {
  const filters =
    filterSource?.find((item) => item?.name === selectedCategory)?.filters || [];

  let values;

  if (selectedCategory === "disposition") {
    values = filters.map(f => f.key);
  } else if (objectCategories.includes(selectedCategory)) {
    values = filters.map(f => f.id);
  } else {
    values = filters.map(f => f.name || f);
  }

  setCategorySelections({
    ...categorySelections,
    [selectedCategory]: values,
  });
};



  const clearAll = () => {
    setCategorySelections({});
    dispatch(clearQuery());
    // setSecondaryItems([]);
  };


  const applyFilters = () => {
    setOpen(false);
    setReadyToApply(true);
    dispatch(setQuery(categorySelections));
    updateApis(categorySelections);
    if (typeof fetchData === "function") {
      dispatch(fetchData(categorySelections)).then(() =>
        setReadyToApply(false)
      );
    }
    if (typeof fetchData2 === "function") {
      dispatch(fetchData2(categorySelections));
    }
    if (typeof fetchData3 === "function") {
      dispatch(fetchData3(categorySelections));
    }
  };

  console.log(categorySelections, 'categorySelections');


  const toggleFavorite = (trust) => {
    // Implement favorite logic if needed
  };

  const handleSelectCategory = (cat) => {
    console.log(cat, 'kldjfkdjf');
    setSelectedCategory(cat?.value);
    // if (cat.title !== "Favourites" && cat.title !== "Recently Selected") {
    //   setPrimaryItems([cat?.title]);
    // }
  };



  const filteredCategories = useMemo(() => {
    if (!searchTerm) {
      // Default: show all categories with all their filters
      return categories.map((cat) => ({
        ...cat,
        filteredFilters:
          filterSource?.find((f) => f.name === cat.value)?.filters || [],
      }));
    }

    // New: Global search results
    let searchResults = [];
    categories.forEach((cat) => {
      const allFilters =
        filterSource?.find((f) => f.name === cat.value)?.filters || [];

      const matchedFilters = allFilters.filter((filter) =>
        filter.toLowerCase().includes(searchTerm.toLowerCase())
      );

      if (matchedFilters.length > 0) {
        searchResults.push(...matchedFilters.map((f) => ({ filter: f, category: cat.title })));
      }
    });

    // If we have global results, create a single "Search Results" category
    if (searchResults.length > 0) {
      return [
        {
          title: "Search Results",
          value: "search_results",
          filteredFilters: searchResults.map((res) => `${res.filter} (${res.category})`),
        },
      ];
    }

    return [];
  }, [categories, filterSource, searchTerm]);

  const dropdownContent = (
    <div className="custom-dropdown">
      <div className="filter-header">
        <div>
          <h2>Filter</h2>
          <img
            src={crossIcon}
            alt="Close"
            height={15}
            width={15}
            onClick={() => setOpen(false)}
          />
        </div>
        <Input
          prefix={<img src={searchIcon} alt="Search Icon" />}
          placeholder="Search"
          allowClear
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="status-line">
        <div>Category</div>
        <div>Metric</div>
        <div>Selected</div>
      </div>
      <div className="filter-body">
        <div className="filter-categories">
          {filteredCategories?.map((cat, index) => {
            const isDividerNeeded = cat.title === "Favourites";
            return (
              <React.Fragment key={index}>
                <Button
                  className={selectedCategory === cat?.value ? "active" : ""}
                  onClick={() => handleSelectCategory(cat)}
                  block
                  icon={
                    cat.title === "Recently Selected" ? (
                      <img src={recentIcon} alt="recent" />
                    ) : cat.title === "Favourites" ? (
                      <img src={favoIcon} alt="favourites" />
                    ) : null
                  }
                >
                  {cat?.title}
                </Button>
                {isDividerNeeded && <div className="divider-container" />}
              </React.Fragment>
            );
          })}
        </div>
        <div className="filter-metrics">
          <div className="select-all">
            <button onClick={handleSelectAll}>Select All</button>
          </div>
          <div className="trust-list">
            {filteredCategories
              .find((c) => c.value === selectedCategory)
              ?.filteredFilters?.length > 0 ? filteredCategories
                .find((c) => c.value === selectedCategory)
                ?.filteredFilters?.map((trust) => (
                  <div key={trust.id || trust} className="trust-item">
                    <Checkbox
                     checked={
  selectedCategory === "disposition"
    ? (categorySelections[selectedCategory] || []).includes(trust.key)
    : objectCategories.includes(selectedCategory)
      ? (categorySelections[selectedCategory] || []).includes(trust.id)
      : (categorySelections[selectedCategory] || []).includes(trust)
}

                      onChange={() =>
                        objectCategories.includes(selectedCategory)
                          ? toggleTrust(trust)
                          : toggleTrust(trust)
                      }
                    >
                      {trust?.name || trust?.key || trust}
                    </Checkbox>
                    <span
                      className="favorite-icon"
                      onClick={() => toggleFavorite(trust)}
                    >
                      <img src={starIcon} alt="star" />
                    </span>
                  </div>
                )) : <div style={{ height: '100%', paddingTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Empty description="No Data" />
            </div>}
          </div>

        </div>
        <div className="filter-selected">
          {Object.entries(categorySelections).map(([cat, selected]) =>
            selected?.map((trustId) => {
              // Hide trust_id items if pathname starts with /analysis/
              if (cat === 'trust_id' && pathname.startsWith('/analysis/')) {
                return null;
              }
              let displayName = trustId;
              if (objectCategories.includes(cat)) {
                const filterObj =
                  filterSource.find((f) => f.name === cat)?.filters.find((f) => f.id === trustId);
                displayName = filterObj?.name || filterObj?.key || filterObj?.email || trustId;
              }
              return (
                <Tag
                  key={cat + trustId}
                  closable
                  onClose={() => {
                    const updated = selected.filter((t) => t !== trustId);
                    setCategorySelections({ ...categorySelections, [cat]: updated });
                  }}
                  closeIcon={<CloseOutlined />}
                >
                  {displayName}
                </Tag>
              );
            })
          )}
        </div>
      </div>
      <div className="filter-footer">
        <Button onClick={clearAll} type="text">
          Clear all
        </Button>
        <Button onClick={applyFilters} type="primary">
          Apply
        </Button>
      </div>
    </div>
  );

  const mobileMenuDropdownContent = (
    <div className="custom-dropdown mobile-dropdown">
      <div className="filter-header">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 style={{ fontSize: 16, fontWeight: 600 }}>Filter</h2>
          <img
            src={crossIcon}
            alt="Close"
            height={16}
            width={16}
            style={{ cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </div>
      </div>

      <Collapse defaultActiveKey={["1"]}>
        {filteredCategories?.map((cat, index) => {
          const currentFilter = cat.filteredFilters;
          const currentSelections = categorySelections[cat.value] || [];
          return (
            <Panel
              header={
                <Flex gap={2}>
                  <Badge count={currentSelections?.length} offset={[10, 1]}>
                    <h2 style={{ fontSize: 13, fontWeight: 500 }}>
                      {cat?.title}
                    </h2>
                  </Badge>
                </Flex>
              }
              key={index + 1}
              className="filter-panel"
            >
              <div className="filter-metrics">
                <div className="select-all">
                  <button
                    onClick={() => {
                      const values = objectCategories.includes(cat.value)
                        ? currentFilter.map(f => f.id)
                        : currentFilter.map(f => f.name || f);
                      const updatedSelections = {
                        ...categorySelections,
                        [cat.value]: values,
                      };
                      setCategorySelections(updatedSelections);
                    }}
                  >
                    Select All
                  </button>
                </div>
                <div className="trust-list">
                  {currentFilter.length > 0 ? currentFilter.map((trust) => (
                    <div key={trust.id || trust} className="trust-item">
                      <Checkbox
                      checked={
  selectedCategory === "disposition"
    ? (categorySelections[selectedCategory] || []).includes(trust.key)
    : objectCategories.includes(selectedCategory)
      ? (categorySelections[selectedCategory] || []).includes(trust.id)
      : (categorySelections[selectedCategory] || []).includes(trust)
}

                        onChange={() => {
                          let updated;
                          if (objectCategories.includes(cat.value)) {
                            const trustId = trust.id || trust;
                            updated = currentSelections.includes(trustId)
                              ? currentSelections.filter((t) => t !== trustId)
                              : [...currentSelections, trustId];
                          } else {
                            updated = currentSelections.includes(trust)
                              ? currentSelections.filter((t) => t !== trust)
                              : [...currentSelections, trust];
                          }
                          const updatedSelections = {
                            ...categorySelections,
                            [cat.value]: updated,
                          };
                          setCategorySelections(updatedSelections);
                        }}
                      >
                        {trust?.name || trust}
                      </Checkbox>
                      <span
                        className="favorite-icon"
                        onClick={() => toggleFavorite(trust)}
                      >
                        <img src={starIcon} alt="star" />
                      </span>
                    </div>
                  )) : <div style={{ height: '100%', paddingTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Empty description="No Data" />
                  </div>}
                </div>
                {/* Tag rendering for selected filters in this category */}
                {/* <div className="filter-selected">
                  {currentSelections.map((trustId) => {
                    let displayName = trustId;
                    if (objectCategories.includes(cat.value)) {
                      const filterObj =
                        filterSource.find((f) => f.name === cat.value)?.filters.find((f) => f.id === trustId);
                      displayName = filterObj?.name || filterObj?.email || trustId;
                    }
                    return (
                      <Tag
                        key={cat.value + trustId}
                        closable
                        onClose={() => {
                          const updated = currentSelections.filter((t) => t !== trustId);
                          setCategorySelections({ ...categorySelections, [cat.value]: updated });
                        }}
                        closeIcon={<CloseOutlined />}
                      >
                        {displayName}
                      </Tag>
                    );
                  })}
                </div> */}
              </div>
            </Panel>
          );
        })}
      </Collapse>

      <div className="filter-footer">
        <Button onClick={clearAll} type="text">
          Clear all
        </Button>
        <Button onClick={applyFilters} type="primary">
          Apply
        </Button>
      </div>
    </div>
  );

  const isDropdown = useMemo(() => {
    return screenWidth > 800 ? dropdownContent : mobileMenuDropdownContent;
  }, [screenWidth, filteredCategories, categorySelections, searchTerm]);


  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      dropdownRender={() => isDropdown}
      placement="bottomLeft"
      trigger={["click"]}
    >
      {variant === "2" ? (
        <img
          src={FilterIcon2}
          alt="Filter Icon"
          style={{ cursor: "pointer" }}
        />
      ) : (
        <Button
          style={{ height: "35px", fontWeight: 500 }}
          className="filter-btn"
        >
          Filter <DownOutlined />
        </Button>
      )}
    </Dropdown>
  );
};

export default FilterDropdown;
